import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";

import "./i18n";

import { QueryClient, QueryClientProvider } from "react-query";
const queryClient = new QueryClient({queries: { staleTime: 20000, refetchOnWindowFocus: false, }});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <QueryClientProvider client={queryClient}>
      <BrowserRouter >
        <App />
      </BrowserRouter>
    </QueryClientProvider>

);

// root.render(
//   <React.StrictMode>
//     <QueryClientProvider client={queryClient}>
//       <BrowserRouter >
//         <App />
//       </BrowserRouter>
//     </QueryClientProvider>
//   </React.StrictMode>
// );


// reportWebVitals();
